import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'sandcastle',
      d: 'M-1,-4.5h1v0.5h-1zM0.5,-4.5h1v0.5h-1zM-1,-4h2.5v1h-2.5zM-2.5,-3h5v2h-5zM-2.5,-1h1.5v1h-1.5zM-0.5,-1h3.5v1h-3.5zM-0.5,0h2v0.5h-2z',
    },
    { paint: 'trunk', d: 'M0,-5h0.5v1h-0.5zM-1,-1h0.5v1h-0.5z' },
    { paint: 'buoy', d: 'M0,-5.5h1.5v0.5h-1.5zM0.5,-5h0.5v0.5h-0.5z' },
  ],
  pixels: 86,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
